export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9493.16bcc329.jpg";